import { connect } from 'react-redux';
import storage from 'app/services/storage';
import moviesModule from 'app/store/movies';
import layoutModule from 'app/store/layout';
import AllMovies from './AllMovies.component';
import orderModule from 'app/store/order';

const { clearErrorApi } = layoutModule.actions;
const { clearOrder } = orderModule.actions;

const {
  requestTopMovies,
  requestNowPlayingMovies,
  requestUpcomingMovies,
  setDate,
  resetStateMovies,
  advertiseBanner
} = moviesModule.actions;

const mapDispatchToProps = {
  getTopMovies: requestTopMovies,
  getNowPlayingMovies: requestNowPlayingMovies,
  getUpcomingMovies: requestUpcomingMovies,
  setStoreDate: setDate,

  clearErrorApi,
  resetState: resetStateMovies,
  advertisingbanner: advertiseBanner,
  clearOrder,
};

const mapStateToProps = ({ movies, user, layout }) => (
  {
    films: movies.films,
    topNowDates: movies.dates,
    upcomingDates: movies.upcomingDates,
    storeDate: movies.date,
    advertiseData: movies.advertisement,
    locations: layout.locations,
    isLoggedIn: !!user.user,
    savedLocation: storage.getLocation(),
    saveLocation: location => {
      storage.setLocation(location);
    }
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllMovies);
